// Props that make a non-button element (a card, a row) work like a button from
// the keyboard: focusable, announced as a button, and activated by Enter/Space.
// Prefer a real <button> or <Link> for new code; this is for existing layouts.
export const pressable = (handler) => ({
  role: "button",
  tabIndex: 0,
  onClick: handler,
  onKeyDown: (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler(event);
    }
  },
});
